exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DefaultReports {\n  color: #aaa;\n  margin-left: 10px;\n  white-space: nowrap;\n  width: auto;\n}\n\n.DefaultReports div span {\n  display: table-cell;\n  font-size: 12px;\n  padding-right: 2px;\n}\n\n.DefaultReports .details {\n  text-transform: none;\n}\n\n.DefaultReports .Loading {\n  margin: 0 29px 0 -9px;\n}\n\n.DefaultReports .unable-to-fetch-data {\n  color: #9E9E9E;\n  font-size: 12px;\n}", ""]);

// exports
